module.exports = __webpack_public_path__ + "6163887e2051f96e71c8f17004b69dcd.svg";